module.exports = __webpack_public_path__ + "static/assets/1e03b198c2ee283a65eed7dc3df6592a.png";